const mapping = {
  male: 'ANALYTICS.CHARTS.MALE',
  female: 'ANALYTICS.CHARTS.FEMALE',
  loginRut: 'Rut',
  loginFacebook: 'Facebook',
  loginForeign: 'ANALYTICS.CHARTS.FOREIGNERS',
  register: 'ANALYTICS.CHARTS.REGISTER',
  loginBanco: 'ANALYTICS.CHARTS.BANK',
  loginCode: 'ANALYTICS.CHARTS.CODE',
  loginEMail: 'Email',
  loginEmpleados: 'ANALYTICS.CHARTS.EMPLOYEES',
  loginMixto: 'Mixto',
  loginTravellers: 'ANALYTICS.CHARTS.TRAVELLERS',
  loginWhitelist: 'ANALYTICS.CHARTS.WHITELIST',
  one_time: 'ANALYTICS.CHARTS.ONE_TIME',
  returning: 'ANALYTICS.CHARTS.RETURNING',
  hour: 'ANALYTICS.CHARTS.HOUR',
  day: 'ANALYTICS.CHARTS.DAY',
  week: 'ANALYTICS.CHARTS.WEEK',
  month: 'ANALYTICS.CHARTS.MONTH',
  showPortal: 'ANALYTICS.CHARTS.SHOW_PORTAL',
  logins: 'ANALYTICS.CHARTS.LOGINS',
  videoFinish: 'ANALYTICS.CHARTS.VIDEO_FINISH',
  uniqueLogins: 'ANALYTICS.CHARTS.UNIQUE_LOGINS',
  appFinish: 'ANALYTICS.CHARTS.APP_FINISH',
  formFinish: 'ANALYTICS.CHARTS.FORM_FINISH',
}

function translateKey(key) {
  return mapping[key] ?? `NT! ${key}`;
};

export default translateKey